import React from 'react';
import {Button, Input} from "../../components/common";
import * as Yup from "yup";
import {useFormik} from "formik";
import {ALERT_TYPES, INPUT_TYPES, ROUTES} from "../../types";
import {useMutation} from "react-query";
import {useAlert} from "../../components/common/Alert";
import {useNavigate} from "react-router-dom";

interface ISchema {
  [key: string]: string;
  email: string;
}

const ResetPassword = () => {
  const navigate = useNavigate();
  const { setAlert } = useAlert();

  const resetSendEmail = useMutation(["resetEmail"], {
    onMutate: (data: { email: string }) => {},
    onSuccess: () => {
      setAlert('Проверьте вашу почту, была выслана ссылка на сброс пароля!', ALERT_TYPES.SUCCESS);
      navigate(ROUTES.SIGN_IN);
    },
    onError: (e: any) => {
      setAlert(`${e.response.data.email.flat(2)?.[0]}`, ALERT_TYPES.ERROR);
    }
  })

  const validationSchema: Yup.Schema<ISchema> = Yup.object().shape({
    email: Yup.string()?.email('Невалидный email').required('Email не может быть пустым'),
  });

  const submitForm = async (values: any) => {
    const { email } = values;
    await resetSendEmail.mutate({ email })
  }

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: submitForm
  });

  const {
    errors, touched
  } = formik;

  const handleSubmit = () => formik.handleSubmit();

  return (
    <div className="bg-signIn bg-no-repeat bg-center bg-cover w-full h-screen flex items-center justify-center">
      <div className="px-5 flex flex-col w-1/2 lg:w-full">
        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Адрес электронной почты</p>
        <Input
          className="w-full"
          id="email"
          name="email"
          type={INPUT_TYPES.EMAIL}
          placeholder="Введите email"
          onChange={formik.handleChange}
          error={touched?.email ? errors?.email : false}
        />

        <Button
          title={'Отправить'}
          onClick={handleSubmit}
          className="w-full mt-6"
        />
      </div>
    </div>
  )
};

export default ResetPassword;
